import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

const MyOrders = () => {
  const navigate = useNavigate();

  const orders = useMemo(() => {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    const ordersKey = user?.email ? `orders_${user.email}` : "orders_guest";
    return JSON.parse(localStorage.getItem(ordersKey)) || [];
  }, []);

  return (
    <>
      <style>{`
        .mo-page{
          min-height:100vh;
          padding:30px 16px;
          background:radial-gradient(circle at top left,#fff7ed,transparent 35%),
          radial-gradient(circle at bottom right,#ede9fe,transparent 35%),
          linear-gradient(180deg,#fff,#faf7ff);
          font-family:Arial,sans-serif;
        }
        .mo-container{max-width:1150px;margin:0 auto;}
        .mo-hero{
          background:linear-gradient(135deg,#3b0764,#7c3aed,#f97316);
          color:#fff;
          border-radius:28px;
          padding:30px;
          box-shadow:0 22px 45px rgba(76,29,149,.25);
          margin-bottom:24px;
        }
        .mo-hero h1{margin:0;font-size:34px;font-weight:900;}
        .mo-hero p{margin:10px 0 0;opacity:.9;}
        .mo-grid{
          display:grid;
          grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
          gap:20px;
        }
        .mo-card{
          background:rgba(255,255,255,.95);
          border:1px solid #ede9fe;
          border-radius:24px;
          padding:18px;
          box-shadow:0 18px 45px rgba(15,23,42,.08);
          transition:.25s;
          cursor:pointer;
        }
        .mo-card:hover{
          transform:translateY(-4px);
          box-shadow:0 24px 55px rgba(124,58,237,.16);
        }
        .mo-top{
          display:flex;
          justify-content:space-between;
          gap:12px;
          align-items:flex-start;
          margin-bottom:14px;
        }
        .mo-id{
          font-weight:900;
          color:#4c1d95;
          font-size:15px;
          word-break:break-word;
        }
        .mo-badge{
          background:#dcfce7;
          color:#166534;
          border-radius:999px;
          padding:6px 10px;
          font-size:12px;
          font-weight:900;
          white-space:nowrap;
        }
        .mo-product{
          display:flex;
          gap:12px;
          align-items:center;
          background:#f9fafb;
          border-radius:16px;
          padding:10px;
          margin-bottom:12px;
        }
        .mo-product img{
          width:58px;
          height:58px;
          border-radius:14px;
          object-fit:cover;
          flex-shrink:0;
        }
        .mo-product h3{
          margin:0 0 5px;
          font-size:15px;
          color:#111827;
        }
        .mo-product p{
          margin:0;
          color:#6b7280;
          font-size:13px;
        }
        .mo-info{
          display:flex;
          justify-content:space-between;
          padding:9px 0;
          border-bottom:1px solid #eee;
          gap:10px;
        }
        .mo-info span{color:#6b7280;font-size:14px;}
        .mo-info strong{color:#111827;font-size:14px;text-align:right;}
        .mo-actions{
          display:flex;
          gap:10px;
          margin-top:16px;
        }
        .mo-btn{
          flex:1;
          border:none;
          border-radius:999px;
          padding:12px;
          font-weight:900;
          cursor:pointer;
        }
        .mo-view{
          background:linear-gradient(135deg,#7c3aed,#a855f7);
          color:#fff;
        }
        .mo-track{
          background:linear-gradient(135deg,#16a34a,#22c55e);
          color:#fff;
        }
        .mo-empty{
          background:#fff;
          border-radius:24px;
          padding:35px;
          text-align:center;
          box-shadow:0 18px 45px rgba(15,23,42,.08);
        }
        .mo-empty h2{margin:0 0 10px;color:#4c1d95;}
        .mo-empty p{color:#6b7280;}
        @media(max-width:600px){
          .mo-page{padding:16px 10px;}
          .mo-hero{border-radius:22px;padding:24px 18px;}
          .mo-hero h1{font-size:28px;}
          .mo-actions{flex-direction:column;}
        }
      `}</style>

      <div className="mo-page">
        <div className="mo-container">
          <div className="mo-hero">
            <h1>My Orders</h1>
            <p>View your previous JyotirVani orders and track delivery status.</p>
          </div>

          {orders.length === 0 ? (
            <div className="mo-empty">
              <h2>No Orders Found</h2>
              <p>Your placed orders will appear here after successful payment.</p>
              <button
                className="mo-btn mo-view"
                onClick={() => navigate("/")}
              >
                Continue Shopping
              </button>
            </div>
          ) : (
            <div className="mo-grid">
              {orders.map((order, index) => {
                const firstProduct = order.cart?.[0] || {};
                const moreItems = Math.max((order.cart?.length || 0) - 1, 0);

                return (
                  <div
                    key={`${order.order_id}-${index}`}
                    className="mo-card"
                    onClick={() =>
                      navigate(`/OrderCreated/${order.order_id}?payment=success`)
                    }
                  >
                    <div className="mo-top">
                      <div>
                        <div className="mo-id">{order.order_id}</div>
                        <p style={{ margin: "6px 0 0", color: "#6b7280", fontSize: 13 }}>
                          {order.orderDate
                            ? new Date(order.orderDate).toLocaleString()
                            : "Date not available"}
                        </p>
                      </div>
                      <span className="mo-badge">Paid</span>
                    </div>

                    <div className="mo-product">
                      <img
                        src={firstProduct.image || "https://via.placeholder.com/80"}
                        alt={firstProduct.name || "Product"}
                      />
                      <div>
                        <h3>{firstProduct.name || "Product details"}</h3>
                        <p>
                          Qty: {firstProduct.quantity || 1}
                          {moreItems > 0 ? ` + ${moreItems} more item` : ""}
                        </p>
                      </div>
                    </div>

                    <div className="mo-info">
                      <span>Total Items</span>
                      <strong>{order.totalItems || order.cart?.length || 0}</strong>
                    </div>

                    <div className="mo-info">
                      <span>Total Paid</span>
                      <strong>₹{order.grandTotal || 0}</strong>
                    </div>

                    <div className="mo-info">
                      <span>Payment</span>
                      <strong>Razorpay</strong>
                    </div>

                    <div className="mo-actions">
                      <button
                        className="mo-btn mo-view"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/OrderCreated/${order.order_id}?payment=success`);
                        }}
                      >
                        View Order
                      </button>

                      <button
                        className="mo-btn mo-track"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/TrackOrder/${order.order_id}?payment=success`);
                        }}
                      >
                        Track
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MyOrders;